import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Radio,
  Stack,
  styled,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_EMPOYEES_JOB_4 } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { ClientQualityControlModel } from "./ClientQualityControlModel";

export default function ClientQualityControlDetails() {
  const [selectedJob, setSelectedJob] = useState({});
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_PROGRESS_DETAILS, TEXT_SUBMITTED_DETAILS, TEXT_DETAILS_DRAFT } =
    ClientEnglishFallback.QualityControlDetails(multiLanguageData?.QualityControlDetails || {});
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const { qid: id } = useParams();
  const nav = useNavigate();

  const [modelOpen, setModelOpen] = useState(false);
  const [packageList, setPackagesList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [packageDetails, setDataForPckDetails] = useState(null);
  const [fullScreenLoader, setFullScreenLoader] = useState(false);

  useEffect(() => {
    if (id) {
      fetchJobs();
    } else {
      nav("../quality-control");
    }
  }, []);

  const fetchJobs = async () => {
    setFullScreenLoader(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            id: id
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_EMPOYEES_JOB_4, obj, loginData?.accessToken);
      if (res?.status === 200) {
        let data = res?.data?.data;
        setSelectedJob(data?.[0] || {});
        fetchPackages(data?.[0]?.clientJobId);
        setFullScreenLoader(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("fetchJobs-> error ::::::::", error);
    }
  };

  const fetchPackages = async (value) => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientJobId: value
          }
        ]
      };

      let res = await Postrequestcall(
        // FETCH_CLIENT_JOBS_PACKAGE,
        "Client/FetchClientQCJobPackages2",
        obj,
        loginData?.accessToken
      );
      if (res?.status === 200) {
        let data = res?.data?.data;
        handelAllExpanded(data, true);
      }
    } catch (error) {
      console.error("fetchPackages-> error ::::::::", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handelAllExpanded = (data, value) => {
    let data1 = data?.map((item) => {
      return { ...item, expanded: value };
    });

    setPackagesList(data1);
  };

  const ClickableText = styled(Typography)(({ theme }) => ({
    cursor: "pointer",
    transition: " color 0.1s ease",
    "&:hover": {},
    userSelect: "none",
    "&:active": {
      color: "lightgrey"
    }
  }));

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800]
      })
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#1a90ff",
      ...theme.applyStyles("dark", {
        backgroundColor: "#308fe8"
      })
    }
  }));

  return (
    <>
      {fullScreenLoader ? (
        <Loader fullScreen />
      ) : (
        <>
          <Card
            sx={{
              boxShadow: "none",
              borderRadius: "10px",
              width: "100%"
            }}>
            <CardContent>
              <Grid size={12} container>
                <Grid size={12}>
                  <Typography fontSize={17} variant="subtitle1" fontWeight={"bold"}>
                    {selectedJob?.jobName}
                  </Typography>
                </Grid>
                <Grid mb={2} size={12}>
                  <Typography
                    sx={{
                      color: "grey"
                    }}>
                    {selectedJob?.jobCode}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography
                    sx={{
                      color: "grey"
                    }}>
                    {`${selectedJob?.address1}, ${selectedJob?.city}, ${selectedJob?.province}, ${selectedJob?.postalCode}, ${selectedJob?.country}`}
                  </Typography>
                </Grid>
              </Grid>
              <Divider
                sx={{
                  margin: "30px 0px"
                }}
              />
              <Grid container>
                <Grid size={12}>
                  <Stack display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography
                      gutterBottom
                      variant="subtitle2"
                      fontSize={17}
                      component="div"
                      fontWeight={"bold"}
                      color={"grey"}>
                      {TEXT_PROGRESS_DETAILS}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="subtitle2"
                      fontSize={17}
                      component="div"
                      fontWeight={"bold"}
                      color={"grey"}>
                      {parseFloat(Number(selectedJob?.qualityControlProgress)).toFixed(2)}%
                    </Typography>
                  </Stack>
                </Grid>
                <Grid size={12}>
                  <BorderLinearProgress
                    sx={{
                      backgroundColor: "white",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: CLIENT_ACCENT_COLOR
                      }
                    }}
                    variant="determinate"
                    value={selectedJob?.qualityControlProgress || 0}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Grid spacing={1} mt={1} container size={12}>
            {isLoading ? (
              <Stack width={"100%"} justifyContent={"center"}>
                <Loader />
              </Stack>
            ) : packageList?.length === 0  ? (
              <Grid size={12}>
                <Typography variant="body1" textAlign="center" color="textSecondary" sx={{ py: 3 }}>
                  No packages found for this job
                </Typography>
              </Grid>
            ) : (
              packageList?.map((actItem, index) => (
                <React.Fragment key={index}>
                  {actItem?.noOfCountActivity !== 0 && (
                    <Grid size={12} key={index}>
                      <Card
                        onClick={() => {
                          setDataForPckDetails({
                            ...actItem
                          });
                          setModelOpen(true);
                        }}
                        sx={{
                          boxShadow: "none",
                          p: "10px",
                          borderRadius: "10px"
                        }}>
                        <div key={index}>
                          {actItem?.isDraft && (
                            <FormControlLabel
                              key={index}
                              value="male"
                              checked={true}
                              control={
                                <Radio
                                  checkedIcon={
                                    <ErrorIcon
                                      style={{
                                        color: "#ffbc0a"
                                      }}
                                    />
                                  }
                                />
                              }
                              label={
                                <Box>
                                  <Typography variant="body1">{actItem?.packageName}</Typography>
                                  <Typography
                                    variant="caption"
                                    fontStyle={"italic"}
                                    sx={{
                                      color: "#656565"
                                    }}
                                    fontWeight={"bold"}>
                                    {TEXT_DETAILS_DRAFT}{" "}
                                    {moment(actItem?.draftDate).format("MMMM DD, YYYY hh:mm a")}
                                  </Typography>
                                </Box>
                              }
                            />
                          )}

                          {actItem?.isSubmit && (
                            <FormControlLabel
                              key={index}
                              // onClick={() => {
                              //   setDataForPckDetails({
                              //     ...actItem
                              //   });
                              //   setModelOpen(true);
                              // }}
                              control={
                                <Radio
                                  checkedIcon={
                                    <CheckCircleIcon
                                      style={{
                                        color: "green"
                                      }}
                                    />
                                  }
                                />
                              }
                              checked={true}
                              label={
                                <Box>
                                  <ClickableText variant="body1">
                                    {actItem?.packageName}
                                  </ClickableText>
                                  <ClickableText variant="caption" color="textSecondary">
                                    {TEXT_SUBMITTED_DETAILS}{" "}
                                    {moment(actItem?.submitDate).format("MMMM DD, YYYY hh:mm a")}
                                  </ClickableText>
                                </Box>
                              }
                            />
                          )}

                          {!actItem?.isSubmit && !actItem?.isDraft && (
                            <FormControlLabel
                              // onClick={() => {
                              //   setDataForPckDetails({
                              //     ...actItem
                              //   });
                              //   setModelOpen(true);
                              // }}
                              checked={false}
                              control={<Radio />}
                              label={actItem?.packageName}
                            />
                          )}
                        </div>
                      </Card>
                    </Grid>
                  )}
                </React.Fragment>
              ))
            )}
          </Grid>
        </>
      )}

      <ClientQualityControlModel
        selectedPackage={packageDetails}
        isOpen={modelOpen}
        reLoadData={() => {
          fetchJobs();
        }}
        onClose={() => {
          setModelOpen(false);
        }}
      />
    </>
  );
}
